(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pie-nuevo-claude"]) return;
  try {
    
  (function () {
    if (window.__pncFooterInit) return;
    window.__pncFooterInit = true;
    var mq = window.matchMedia('(max-width: 749px)');

    function sync() {
      document.querySelectorAll('.pnc-col__h').forEach(function (b) {
        if (mq.matches) {
          b.removeAttribute('aria-disabled');
          b.removeAttribute('tabindex');
          b.setAttribute('aria-expanded', b.parentNode.classList.contains('is-open') ? 'true' : 'false');
        } else {
          b.removeAttribute('aria-expanded');
          b.setAttribute('aria-disabled', 'true');
          b.setAttribute('tabindex', '-1');
        }
      });
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.pnc-col__h') : null;
      if (!b || !mq.matches) return;
      var col = b.parentNode;
      var open = !col.classList.contains('is-open');
      col.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
    document.addEventListener('shopify:section:load', sync);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"] && !Shopify.designMode) return;
  try {
    
  const CART_EVENT_NAME = 'shopify:cart:lines-update';
  class CartLinesUpdateEventLite extends Event {
    constructor(payload) {
      super(CART_EVENT_NAME, { bubbles: true, cancelable: true });
      Object.assign(this, payload);
    }
  }
  function createDeferred() {
    let resolve, reject;
    const promise = new Promise((res, rej) => { resolve = res; reject = rej; });
    return { promise, resolve, reject };
  }

  if (!customElements.get('mf-product-information')) {
    customElements.define('mf-product-information', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.waiting = this.dataset.requireChoice === 'true';
        this.loading = false;
        this.failed = false;
        this.submitting = false;
        this.sequence = 0;
        this.addEventListener('change', event => this.onChange(event), options);
        this.addEventListener('click', event => this.onClick(event), options);
        this.addEventListener('submit', event => this.onSubmit(event), options);
        window.addEventListener('pageshow', () => { this.submitting = false; this.updateButton(); }, options);
        window.addEventListener('storage', () => this.updateWishlist(), options);
        this.prepareChoices();
        this.updateButton();
        this.updateWishlist();
        this.updateFeaturedMedia();
        this.broadcastPrice();
        this.updateGalleryNav();
        this.querySelector('[data-gallery]')?.addEventListener('scroll', () => this.updateGalleryNav(), { signal: this.events.signal, passive: true });
        window.addEventListener('resize', () => this.updateGalleryNav(), options);
        this.relocateUpsell();
        this.relocateKiwiGuide();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.request?.abort();
        this.events = null;
      }
      prepareChoices() {
        this.querySelectorAll('[data-option-position]').forEach(fieldset => {
          const selected = fieldset.querySelector('input:checked');
          if (selected) fieldset.dataset.selectedValue = selected.value;
          if (this.waiting && fieldset.dataset.isSize === 'true') {
            fieldset.querySelectorAll('input').forEach(input => { input.checked = false; });
          }
        });
      }
      updateButton() {
        const button = this.querySelector('[data-add]');
        if (!button) return;
        const variant = this.querySelector('[data-variant-id]');
        const valid = Boolean(variant?.value && !variant.disabled);
        const canBuy = valid && button.dataset.purchasable === 'true';
        button.dataset.waiting = String(this.waiting && !this.loading && !this.failed);
        button.disabled = this.loading || this.failed || this.submitting || (!this.waiting && !canBuy);
        button.textContent = this.loading || this.submitting ? button.dataset.loadingLabel
          : this.failed ? button.dataset.unavailableLabel
          : this.waiting ? button.dataset.chooseLabel
          : !valid ? button.dataset.unavailableLabel
          : !canBuy ? button.dataset.soldLabel : button.dataset.addLabel;
      }
      broadcastPrice() {
        const priceValue = this.querySelector('[data-price-value]');
        const comparePrice = this.querySelector('[data-compare-price]');
        const priceBox = this.querySelector('[data-price]');
        const addButton = this.querySelector('[data-add]');
        document.dispatchEvent(new CustomEvent('mf:price-update', { detail: {
          productId: this.dataset.productId,
          price: priceValue ? priceValue.textContent.trim() : '',
          comparePrice: (comparePrice && !comparePrice.hidden) ? comparePrice.textContent.trim() : '',
          discountPercent: priceBox ? Number(priceBox.dataset.discountPercent || 0) : 0,
          purchasable: addButton ? addButton.dataset.purchasable === 'true' : false,
          requireChoice: this.waiting
        } }));
      }
      onChange(event) {
        if (event.target.matches('[data-plan]')) { this.updatePlanPrice(); return; }
        if (event.target.matches('[data-package-select]')) {
          const quantityInput = this.querySelector('[name="quantity"]');
          if (quantityInput) quantityInput.value = event.target.value;
          return;
        }
        if (!event.target.matches('[data-option-value-id]')) return;
        const input = event.target;
        const fieldset = input.closest('[data-option-position]');
        const selectedNode = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
        fieldset.dataset.selectedValue = input.value;
        if (fieldset.dataset.isSize !== 'true') this.colorPicked = true;
        if (fieldset.dataset.isSize === 'true') this.waiting = false;
        const sibling = selectedNode?.dataset.productUrl;
        if (sibling) {
          const destination = new URL(sibling, location.origin);
          if (destination.origin !== location.origin) return;
          if (destination.pathname !== new URL(this.dataset.productUrl, location.origin).pathname) {
            // Combined listings can have different option IDs/templates: load their own page.
            const preview = new URL(location.href).searchParams.get('preview_theme_id');
            if (preview) destination.searchParams.set('preview_theme_id', preview);
            location.assign(destination.href);
            return;
          }
        }
        this.refresh(input.id);
      }
      async refresh(focusId) {
        this.request?.abort();
        const controller = new AbortController();
        this.request = controller;
        const sequence = ++this.sequence;
        const selected = [...this.querySelectorAll('[data-option-position]')].map(fieldset =>
          fieldset.querySelector('input:checked')?.value || fieldset.dataset.selectedValue
        );
        if (selected.some(value => !value)) { this.loading = false; this.failed = true; this.removeAttribute('aria-busy'); this.showError(); this.updateButton(); return; }
        const url = new URL(this.dataset.productUrl, location.origin);
        url.search = location.search;
        url.searchParams.delete('variant');
        url.searchParams.delete('selling_plan');
        url.searchParams.set('option_values', selected.join(','));
        url.searchParams.set('section_id', this.dataset.sectionId);
        const openAccordions = [...this.querySelectorAll('[data-accordion][open]')].map(item => item.dataset.accordion);
        const quantity = this.querySelector('[name="quantity"]')?.value;
        const plan = this.querySelector('[data-plan]')?.value;
        this.loading = true;
        this.failed = false;
        this.setAttribute('aria-busy', 'true');
        const error = this.querySelector('[data-error]');
        if (error) error.hidden = true;
        const retry = this.querySelector('[data-retry]');
        if (retry) retry.hidden = true;
        this.updateButton();
        let timeout;
        try {
          timeout = setTimeout(() => controller.abort(), 15000);
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Section request failed');
          const html = await response.text();
          if (sequence !== this.sequence || !this.isConnected) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const next = doc.getElementById(this.id);
          if (!next || next.dataset.productId !== this.dataset.productId || !next.querySelector('[data-variant-id]')) throw new Error('Invalid section');
          // Replace only product content. Keep app blocks and existing media players mounted.
          this.relocateUpsell(next);
          this.relocateKiwiGuide(next);
          this.querySelector('[data-product-content]').replaceWith(next.querySelector('[data-product-content]'));
          const featured = next.querySelector('[data-featured-media]');
          if (featured) this.querySelector('[data-featured-media]')?.replaceWith(featured);
          this.prepareChoices();
          this.querySelectorAll('[data-accordion]').forEach(item => {
            item.open = openAccordions.includes(item.dataset.accordion);
          });
          const quantityInput = this.querySelector('[name="quantity"]');
          if (quantityInput && quantityInput.type === 'number') {
            const min = Number(quantityInput.min) || 1;
            const step = Number(quantityInput.step) || 1;
            const max = Number(quantityInput.max) || Infinity;
            const requested = Math.max(min, Number(quantity) || min);
            const capped = Math.min(requested, max);
            quantityInput.value = String(min + Math.max(0, Math.floor((capped - min) / step)) * step);
          }
          const planSelect = this.querySelector('[data-plan]');
          if (planSelect && [...planSelect.options].some(option => option.value === plan)) planSelect.value = plan;
          this.updatePlanPrice();
          this.updateWishlist();
          this.updateFeaturedMedia();
          this.broadcastPrice();
          const canonical = new URL(location.href);
          canonical.searchParams.delete('section_id');
          canonical.searchParams.delete('selling_plan');
          const variant = this.querySelector('[data-variant-id]');
          if (variant.value && !this.waiting) {
            canonical.searchParams.set('variant', variant.value);
            canonical.searchParams.delete('option_values');
          } else {
            canonical.searchParams.delete('variant');
            canonical.searchParams.set('option_values', selected.join(','));
          }
          if (!window.Shopify?.designMode) history.replaceState({}, '', canonical);
          this.querySelector('[data-status]').textContent = this.querySelector('[data-price]').textContent.trim();
          this.querySelectorAll('[data-option-value-id]').forEach(input => { if (input.id === focusId) input.focus({ preventScroll: true }); });
        } catch (error) {
          if (sequence !== this.sequence || !this.isConnected) return;
          this.failed = true;
          this.showError();
        } finally {
          clearTimeout(timeout);
          if (sequence === this.sequence) {
            this.loading = false;
            this.removeAttribute('aria-busy');
            this.updateButton();
          }
        }
      }
      relocateUpsell(root) {
        const slot = (root || this).querySelector('[data-upsell-slot]');
        if (!slot) return;
        const tryMove = () => {
          const upsell = document.querySelector('[data-ss-upsell-root]');
          if (upsell && upsell.parentElement !== slot) {
            slot.appendChild(upsell);
            return true;
          }
          return false;
        };
        if (tryMove()) return;
        this._upsellObserver?.disconnect();
        const observer = new MutationObserver(() => { if (tryMove()) observer.disconnect(); });
        observer.observe(document.body, { childList: true, subtree: true });
        this._upsellObserver = observer;
        setTimeout(() => observer.disconnect(), 15000);
      }
      relocateKiwiGuide(root) {
        const slot = (root || this).querySelector('[data-kiwi-guide-slot]');
        if (!slot) return;
        const finalize = widget => {
          const firstTime = widget.dataset.relocated !== 'true';
          widget.dataset.relocated = 'true';
          slot.appendChild(widget);
          if (firstTime) {
            const text = widget.querySelector('._ks_text');
            if (text) text.textContent = 'Guida alle taglie';
            const link = widget.querySelector('[aria-label="link to open Size Chart Modal"]');
            if (link) link.setAttribute('aria-label', 'Apri la guida alle taglie');
          }
        };
        const existing = this.querySelector('.ks-chart-container');
        if (existing) { finalize(existing); return; }
        this._kiwiObserver?.disconnect();
        const observer = new MutationObserver(() => {
          const widget = this.querySelector('.ks-chart-container');
          if (widget) { observer.disconnect(); finalize(widget); }
        });
        observer.observe(this, { childList: true, subtree: true });
        this._kiwiObserver = observer;
        setTimeout(() => observer.disconnect(), 20000);
      }
      updatePlanPrice() {
        const selected = this.querySelector('[data-plan]')?.selectedOptions[0];
        if (!selected) return;
        this.querySelector('[data-price-value]').textContent = selected.dataset.price;
        const compare = this.querySelector('[data-compare-price]');
        compare.textContent = selected.dataset.compare || '';
        compare.hidden = !selected.dataset.compare;
        const unit = this.querySelector('[data-unit-price]');
        if (unit) unit.textContent = selected.dataset.unit || '';
        this.broadcastPrice();
      }
      updateFeaturedMedia() {
        const id = this.querySelector('[data-featured-media]')?.dataset.featuredMedia;
        const gallery = this.querySelector('[data-gallery]');
        if (!id || !gallery) return;
        // Solo producto con data-gallery-start-first (ver constante al principio del archivo): hasta que la clienta elija un
        // color, no se adelanta la foto del color preseleccionado; la galeria se queda en la foto 1.
        if (this.dataset.galleryStartFirst === 'true' && !this.colorPicked) { this.updateGalleryNav(); return; }
        const media = [...gallery.children].find(item => item.dataset.mediaId === id);
        if (media) {
          gallery.prepend(media);
          gallery.scrollLeft = 0;
        }
        this.updateGalleryNav();
      }
      jumpToFeaturedMedia() {
        this.updateFeaturedMedia();
        const go = window.__mfgGo;
        const id = this.querySelector('[data-featured-media]')?.dataset.featuredMedia;
        const wrap = this.querySelector('[data-gallery-wrap]');
        if (typeof go !== 'function' || !id || !wrap) return;
        const file = u => String(u || '').split('?')[0].split('/').pop();
        const zoom = wrap.querySelector('.mf-media[data-media-id="' + id + '"] [data-zoom-src]');
        if (!zoom) return;
        const key = file(zoom.dataset.zoomSrc);
        const thumbs = wrap.querySelectorAll('.mfg-thumb');
        for (let i = 0; i < thumbs.length; i++) {
          const im = thumbs[i].querySelector('img');
          if (im && file(im.getAttribute('src')) === key) { go(i); return; }
        }
      }
      updateGalleryNav() {
        const gallery = this.querySelector('[data-gallery]');
        const prev = this.querySelector('[data-gallery-prev]');
        const next = this.querySelector('[data-gallery-next]');
        if (!gallery || !prev || !next) return;
        const maxScroll = gallery.scrollWidth - gallery.clientWidth;
        if (maxScroll <= 2) { prev.hidden = true; next.hidden = true; return; }
        prev.hidden = gallery.scrollLeft <= 2;
        next.hidden = gallery.scrollLeft >= maxScroll - 2;
      }
      onSubmit(event) {
        if (!event.target.matches('.mf-form')) return;
        event.preventDefault();
        if (this.loading || this.failed || this.submitting) return;
        if (this.waiting) {
          const size = this.querySelector('[data-is-size="true"] input');
          size?.focus({ preventScroll: true });
          size?.closest('fieldset').scrollIntoView({ block: 'nearest', behavior: 'auto' });
          const status = this.querySelector('[data-status]');
          if (status) status.textContent = this.querySelector('[data-add]').dataset.chooseLabel;
          return;
        }
        const button = this.querySelector('[data-add]');
        const variant = this.querySelector('[data-variant-id]');
        if (button.dataset.purchasable !== 'true' || !variant.value || variant.disabled) return;
        this.submitting = true;
        this.updateButton();
        this.addToCartViaAjax(event.target);
      }
      async addToCartViaAjax(form) {
        const formData = new FormData(form);
        const itemCount = Number(formData.get('quantity')) || 1;
        const deferred = createDeferred();
        this.dispatchEvent(new CartLinesUpdateEventLite({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: formData.get('id'), quantity: itemCount }],
          promise: deferred.promise,
        }));
        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/javascript' },
            body: formData,
          }).then(r => r.json());
          if (response.status) {
            throw new Error(response.message || 'Add to cart failed');
          }
          const cartResponse = await fetch(this.dataset.cartUrl + '.json', {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
          }).then(r => r.json());
          deferred.resolve({
            cart: { totalQuantity: cartResponse.item_count },
            detail: {
              items: cartResponse.items,
              source: 'mf-product-information',
              sourceId: this.id,
              itemCount,
              productId: this.dataset.productId,
              didError: false,
            },
          });
        } catch (error) {
          deferred.reject(error);
          this.failed = true;
          this.showError();
        } finally {
          this.submitting = false;
          this.updateButton();
        }
      }
      onClick(event) {
        // Solo producto con data-gallery-start-first: pulsar un color (aunque ya este seleccionado, caso en que no hay evento change)
        // activa la foto de ese color en la galeria.
        if (this.dataset.galleryStartFirst === 'true') {
          const choiceInput = event.target.closest('.mf-choice')?.querySelector('[data-option-value-id]');
          const choiceSet = choiceInput?.closest('[data-option-position]');
          if (choiceInput && choiceSet && choiceSet.dataset.isSize !== 'true') {
            this.colorPicked = true;
            if (choiceInput.value === choiceSet.dataset.selectedValue && !this.loading) this.jumpToFeaturedMedia();
          }
        }
        const galleryNav = event.target.closest('[data-gallery-prev], [data-gallery-next]');
        if (galleryNav) {
          const gallery = this.querySelector('[data-gallery]');
          if (gallery) gallery.scrollBy({ left: galleryNav.matches('[data-gallery-prev]') ? -gallery.clientWidth : gallery.clientWidth, behavior: 'smooth' });
        }
        const galleryThumb = event.target.closest('.mf-media:not(:first-child)');
        if (galleryThumb && galleryThumb.closest('.mf-gallery') && window.matchMedia('(min-width: 990px)').matches) {
          const gallery = this.querySelector('[data-gallery]');
          if (gallery) { gallery.prepend(galleryThumb); gallery.scrollLeft = 0; }
          return;
        }
        const accordionSummary = event.target.closest('.mf-accordions summary');
        if (accordionSummary) { event.preventDefault(); this.toggleAccordion(accordionSummary.closest('details')); }
        if (event.target.closest('[data-retry]')) this.refresh((this.querySelector('[data-option-value-id]:checked') || this.querySelector('select[data-option-value-id]'))?.id);
        const zoom = event.target.closest('[data-zoom-src]');
        if (zoom) {
          const dialog = this.querySelector('[data-zoom-dialog]');
          const image = dialog.querySelector('img');
          image.src = zoom.dataset.zoomSrc;
          image.alt = zoom.querySelector('img')?.alt || '';
          dialog.showModal();
        }
        if (event.target.closest('[data-close]')) event.target.closest('dialog').close();
        if (event.target.matches('dialog')) {
          const rect = event.target.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
        }
        if (event.target.closest('[data-wishlist]')) this.toggleWishlist();
      }
      toggleAccordion(details) {
        if (!details) return;
        const panel = details.querySelector('.mf-richtext');
        if (!panel) { details.open = !details.open; return; }

        // If this panel is mid-animation, read its current on-screen
        // height so the new animation continues from there instead of
        // jumping.
        let fromHeight = null;
        if (panel._mfAnim) {
          fromHeight = panel.getBoundingClientRect().height;
          panel._mfAnim.cancel();
          panel._mfAnim = null;
        }

        if (!details.open) {
          // Opening: reveal first so we can measure the panel's natural
          // content height, then animate up to it via the Web Animations
          // API. Driving explicit height keyframes (rather than a CSS
          // transition reacting to a class change) avoids relying on the
          // browser's support for animating CSS Grid track sizes, which
          // is what made the previous grid-template-rows technique
          // stutter.
          details.open = true;
          const endHeight = panel.scrollHeight;
          const openAnim = panel.animate(
            [{ height: (fromHeight !== null ? fromHeight : 0) + 'px' }, { height: endHeight + 'px' }],
            { duration: 300, easing: 'ease' }
          );
          panel._mfAnim = openAnim;
          openAnim.onfinish = () => { panel._mfAnim = null; };
          return;
        }
        // Closing: animate the panel's pixel height down to 0 (the
        // chevron keys off ".mf-closing" separately, kept in sync with
        // the same 300ms duration), then actually close the <details>
        // once the animation finishes.
        const startHeight = fromHeight !== null ? fromHeight : panel.scrollHeight;
        details.classList.add('mf-closing');
        const closeAnim = panel.animate(
          [{ height: startHeight + 'px' }, { height: '0px' }],
          { duration: 300, easing: 'ease' }
        );
        panel._mfAnim = closeAnim;
        closeAnim.onfinish = () => {
          details.open = false;
          details.classList.remove('mf-closing');
          panel._mfAnim = null;
        };
      }
      readWishlist() {
        const stored = JSON.parse(localStorage.getItem('martina-faggio:wishlist:v1') || '[]');
        return Array.isArray(stored) ? stored.filter(id => typeof id === 'string') : [];
      }
      updateWishlist() {
        const button = this.querySelector('[data-wishlist]');
        if (!button) return;
        let saved = false;
       try { saved = this.readWishlist().includes(this.dataset.productId); } catch (_) { /* Storage may be unavailable. */ }
        button.setAttribute('aria-pressed', String(saved));
        button.querySelector('[data-wishlist-text]').textContent = saved ? button.dataset.savedLabel : button.dataset.label;
        button.querySelector('[data-wishlist-icon]').textContent = saved ? '♥' : '♡';
      }
      toggleWishlist() {
        try {
          const ids = this.readWishlist();
          const id = this.dataset.productId;
          const next = ids.includes(id) ? ids.filter(value => value !== id) : [...ids, id];
          localStorage.setItem('martina-faggio:wishlist:v1', JSON.stringify(next));
          this.updateWishlist();
          this.querySelector('[data-status]').textContent = this.querySelector('[data-wishlist-text]').textContent;
        } catch (_) { this.showError(true); }
      }
      showError(storage = false) {
        const error = this.querySelector('[data-error]');
        if (!error) return;
        error.textContent = storage ? error.dataset.storageMessage : error.dataset.message;
        error.hidden = false;
        const retry = this.querySelector('[data-retry]');
        if (retry) retry.hidden = storage;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
